import { cn } from '../../lib/utils'

const colors = {
  green:  'bg-emerald-50 text-emerald-700 ring-1 ring-emerald-200',
  red:    'bg-red-50 text-red-700 ring-1 ring-red-200',
  blue:   'bg-blue-50 text-blue-700 ring-1 ring-blue-200',
  yellow: 'bg-amber-50 text-amber-700 ring-1 ring-amber-200',
  gray:   'bg-gray-100 text-gray-600 ring-1 ring-gray-200',
  purple: 'bg-purple-50 text-purple-700 ring-1 ring-purple-200',
  indigo: 'bg-indigo-50 text-indigo-700 ring-1 ring-indigo-200',
  orange: 'bg-orange-50 text-orange-700 ring-1 ring-orange-200',
}

export function Badge({ color = 'gray', children, className }) {
  return (
    <span className={cn('inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium', colors[color], className)}>
      {children}
    </span>
  )
}
